import React from 'react'

export default function Backend() {
  return (
    <div className='my-5'>
        <hr style={{backgroundColor: "black", visibility: "hidden"}}></hr>
        <div className='my-5'>
            <h3>User Buying History</h3>
            <h3>Wil be sought in backend</h3>
        </div>
    </div>
  )
}
